import type { Frame, BodyUUID, UUID } from "../../types/scene";
import { create } from "mutative";
import { generateUuid } from "../../utils/id";
import { logger } from "../../utils/logger";
import { withHistory } from "./withHistory";
import type { SceneStoreSetState, SceneStoreGetState } from "../sceneStore.types";
import type { FrameActions, FrameInput } from "./actionTypes";

export const createFrameActions = (
  set: SceneStoreSetState,
  _get: SceneStoreGetState
): FrameActions => ({
  addFrame: withHistory((frameInput: FrameInput, parentBodyUuid: BodyUUID): string => {
    const uuid = (frameInput.uuid || generateUuid()) as UUID;
    const frame: Frame = {
      ...frameInput,
      uuid,
    };

    set((state) =>
      create(state, (draft) => {
        const parentBody = draft.bodies[parentBodyUuid];
        if (!parentBody) {
          logger.warn(`[addFrame] Parent body ${parentBodyUuid} not found`);
          return;
        }
        if (!parentBody.frames) {
          parentBody.frames = [];
        }
        parentBody.frames.push(frame);
      })
    );
    return uuid;
  }),

  deleteFrame: withHistory((frameUuid: string, parentBodyUuid: BodyUUID) => {
    set((state) =>
      create(state, (draft) => {
        const parentBody = draft.bodies[parentBodyUuid];
        if (!parentBody || !parentBody.frames) return;

        const index = parentBody.frames.findIndex((f: Frame) => f.uuid === frameUuid);
        if (index !== -1) {
          parentBody.frames.splice(index, 1);
        }
      })
    );
  }),
});
